import { Component, Input, OnInit } from '@angular/core';
import { AuthServiceService } from '@services/auth-service.service';
import { RegUser } from '../../pages/basic-reg/RegUser';
import { Globals } from 'src/app/globals';

import { Router } from '@angular/router';
import { ModalController } from '@ionic/angular';
import { LoaderService } from '@services/loader.service';
import { CommonUtil } from 'src/app/util/CommonUtil';
import { TimeZoneUtils } from 'src/app/util/TimeZoneUtils';
import { CommunicationConstants } from 'src/app/constants/CommunicationConstants';

import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-contact-time',
  templateUrl: './contact-time.component.html',
  styleUrls: ['./contact-time.component.scss', '../../../assets/css/style.scss'],
  standalone: true,
  imports: [CommonModule, IonicModule, FormsModule],
})
export class ContactTimeComponent {
  requestPath: string = '';
  errorMessage: string = '';

  loggedInUser: RegUser = new RegUser();

  selectedTab: string = 'tab1';
  selectedCategory: string = 'friends';
  select: boolean = true;
  timeSlotType: string = 'Custom';

  ownerId: number = 0;
  preferredTimeSlotToDisplay: any[] = [];
  preferredCommChanelToDisplay: any[] = [];
  isOlderTime: boolean = false;

  fromTime: string = '';
  toTime: string = '';
  selectAllTimeSlots: boolean = false;
  currentUserTimeZone: string = 'UTC';

  timeSlotsCol1 = CommunicationConstants.timeSlotsCol1;
  timeSlotsCol2 = CommunicationConstants.timeSlotsCol2;
  communicationTypes = CommunicationConstants.communicationTypes;
  userPrefChannel:any = []

  @Input("user") user: any;

  constructor(private authService: AuthServiceService,
    public global: Globals,
    private modalCtrl: ModalController,
    private router: Router,
    private loader: LoaderService) {
    this.requestPath = this.global.requestPath;
    this.userPrefChannel = this.communicationTypes;
  }

  ngOnInit(): void {
  }

  ionViewDidEnter() {
    this.loggedInUser = this.authService.getLoggedInUser();
    this.ownerId = this.loggedInUser.id ?? 0;
    this.currentUserTimeZone = this.loggedInUser.timeZone ?? Intl.DateTimeFormat().resolvedOptions().timeZone ?? 'UTC';
    this.errorMessage = "";

    let selectedCommChannel = "";
    let selectedPrefTimeSlot = ";"
    let selectedFromTime = "";
    let selectedToTime = "";
    if (this.loggedInUser.id == this.user.ownerId) {
      // This user is Sender
      selectedCommChannel = this.user.senderCommChanel;
      this.selectedCategory = this.user.senderCategory;
      selectedPrefTimeSlot = this.user.senderPrefTime;
      selectedFromTime = this.user.senderStartTime;
      selectedToTime = this.user.senderEndTime;
    } else {
      // This user is Reciever
      selectedCommChannel = this.user.recieverCommChanel;
      this.selectedCategory = this.user.recieverCategory;
      selectedPrefTimeSlot = this.user.recieverPrefTime;
      selectedFromTime = this.user.recieverStartTime;
      selectedToTime = this.user.recieverEndTime;
    }
    if (!this.global.isEmpty(selectedFromTime) && !this.global.isEmpty(selectedToTime)) {
      selectedFromTime = TimeZoneUtils.convertUTCToCurrentTime24(selectedFromTime, this.currentUserTimeZone);
      selectedToTime = TimeZoneUtils.convertUTCToCurrentTime24(selectedToTime, this.currentUserTimeZone);
    }

    this.selectAllCommChanel(selectedCommChannel);

    if (selectedFromTime && selectedFromTime.length > 0 && selectedToTime && selectedToTime.length > 0) {
      // Custom time selected
      this.changeTimeSlot('Custom')
      this.fromTime = selectedFromTime;
      this.toTime = selectedToTime;
    } else {
      // Slots selected
      this.changeTimeSlot('Anytime');
      // console.log(selectedPrefTimeSlot);
      if (selectedPrefTimeSlot == "All") {
        this.markSelectallTimeSlotChecked();
        this.markAllSelected(true);
      } else {
        this.markSelectedSlots(selectedPrefTimeSlot);
      }
    }

    // console.log(this.user);
    // console.log(this.personalizedMsg);
    // console.log(this.isSender);
    // console.log(this.isAddButtonVisible);
    // For testing only, need to comment this line
    // var arr = "1,4,22".split(",");
    // this.markTimeSlotSelected(arr);
  }

  markSelectallTimeSlotChecked() {
    let checkbox = document.getElementById('selectAllSlots');
    if (checkbox) {
      checkbox.click();
    }
  }

  async dismiss(data: any) {
    this.modalCtrl.dismiss(data);
  }

  changeTimeSlot(val: any) {
    this.timeSlotType = val;
    this.selectAllTimeSlots = false;
    this.markAllTimeSlots(false);
  }

  changeTimeSelectionType(event: any) {
    var val = event.target.checked;
    this.selectAllTimeSlots = val;
    this.markAllTimeSlots(val);
  }

  changeCategory(val: any) {
    this.selectedCategory = val;
  }

  changeTab(tab: any) {
    this.selectedTab = tab;
  }

  markChecked(id: any) {
    this.selectAllTimeSlots = false;
    for (var timeSlot of this.timeSlotsCol1) {
      if (timeSlot.id == id) {
        timeSlot.checked = !timeSlot.checked;
        return;
      }
    }
    for (var timeSlot of this.timeSlotsCol2) {
      if (timeSlot.id == id) {
        timeSlot.checked = !timeSlot.checked;
        return;
      }
    }
  }

  markSelectedSlots(slotsStr: any) {
    let slotArrStr = slotsStr.split(",");
    let slotArr = [];
    for (var slotStr of slotArrStr) {
      slotArr.push(this.convertTimeSlotToCurrentTime(slotStr));
    }
    for (var timeSlot of this.timeSlotsCol1) {
      if (slotArr.includes(timeSlot.value)) {
        timeSlot.checked = true;
      }
    }
    for (var timeSlot of this.timeSlotsCol2) {
      if (slotArr.includes(timeSlot.value)) {
        timeSlot.checked = true;
      }
    }
  }

  markAllSelected(val: any) {
    this.selectAllTimeSlots = val;
    this.markAllTimeSlots(val);
  }

  markAllTimeSlots(checked: any) {
    for (var timeSlot of this.timeSlotsCol1) {
      timeSlot.checked = checked;
    }
    for (var timeSlot of this.timeSlotsCol2) {
      timeSlot.checked = checked;
    }
  }

  getUserPreferredTime() {
    var preferredTimeSlots = "";
    for (var timeSlot of this.timeSlotsCol1) {
      if (timeSlot.checked) {
        preferredTimeSlots += this.convertTimeSlotToUTC(timeSlot.value) + ",";
      }
    }
    for (var timeSlot of this.timeSlotsCol2) {
      if (timeSlot.checked) {
        preferredTimeSlots += this.convertTimeSlotToUTC(timeSlot.value) + ",";
      }
    }
    return preferredTimeSlots.substring(0, preferredTimeSlots.length - 1);
  }

  selectAllCommChanel(selectedCommChannel: any) {
    let selCommChannelArr = selectedCommChannel.split(",");
    let channelIdArr = [];
    for (var idStr of selCommChannelArr) {
      channelIdArr.push(parseInt(idStr.trim()));
    }
    for (var commType of this.userPrefChannel) {
      if (channelIdArr.includes(commType.id)) {
        commType.checked = true;
      } else {
        commType.checked = false;
      }
    }
  }

  convertTimeSlotToUTC(timeRange: any) {
    let splittedData = timeRange.split("-");
    if (splittedData.length != 2) {
      console.log("Invalid time range: " + timeRange);
      return timeRange;
    }
    return TimeZoneUtils.convertOnlyTimeToUTC(splittedData[0], this.currentUserTimeZone) + "-" + TimeZoneUtils.convertOnlyTimeToUTC(splittedData[1], this.currentUserTimeZone);
  }

  convertTimeSlotToCurrentTime(timeRange: any) {
    let splittedData = timeRange.split("-");
    if (splittedData.length != 2) {
      console.log("Invalid time range: " + timeRange);
      return timeRange;
    }
    return TimeZoneUtils.convertUTCToCurrentTime(splittedData[0], this.currentUserTimeZone) + "-" + TimeZoneUtils.convertUTCToCurrentTime(splittedData[1], this.currentUserTimeZone);
  }

  getPreferredCommChannel() {
    var preferredcommChanels = "";
    for (var commType of this.userPrefChannel) {
      if (commType.checked) {
        preferredcommChanels += commType.id + ",";
      }
    }
    return preferredcommChanels.substring(0, preferredcommChanels.length - 1);
  }

  markTimeSlotSelected(ids: any) {
    for (var timeSlot of this.timeSlotsCol1) {
      if (ids.indexOf(timeSlot.id + "") > -1) {
        timeSlot.checked = true;
      }
    }
    for (var timeSlot of this.timeSlotsCol2) {
      if (ids.indexOf(timeSlot.id + "") > -1) {
        timeSlot.checked = true;
      }
    }
  }

  changeChanel(id: any) {
    for (var commType of this.userPrefChannel) {
      if (commType.id == id) {
        commType.checked = !commType.checked;
        return;
      }
    }
  }

  updateContact() {
    let preferredTimeSlots = '';
    let preferredChanel = '';
    if (this.timeSlotType == "Custom") {
      if (CommonUtil.isEmptyTrim(this.fromTime)) {
        this.errorMessage = "Please select preferred time slots.";
        return;
      }
      if (CommonUtil.isEmptyTrim(this.toTime)) {
        this.errorMessage = "Please select preferred communication channels.";
        return;
      }
    } else {
      preferredTimeSlots = this.selectAllTimeSlots ? "All" : this.getUserPreferredTime();
      preferredChanel = this.getPreferredCommChannel();
      if (CommonUtil.isEmptyTrim(preferredTimeSlots)) {
        this.errorMessage = "Please select preferred time slots.";
        return;
      }
      if (CommonUtil.isEmptyTrim(preferredChanel)) {
        this.errorMessage = "Please select preferred communication channels.";
        return;
      }
    }

    let userContact = {
      "id": this.user.id,
      "ownerId": this.user.ownerId,
      "contactId": this.user.contactId,
      "senderCategory": '',
      "senderStartTime": '',
      "senderEndTime": '',
      "senderPrefTime": '',
      "senderCommChanel": '',
      "recieverCategory": '',
      "recieverStartTime": '',
      "recieverEndTime": '',
      "recieverPrefTime": '',
      "recieverCommChanel": ''
    };

    // console.log("Loggedin user: " + this.user.ownerId);
    if (this.loggedInUser.id == this.user.ownerId) {
      // Sender side
      userContact.senderCategory = this.selectedCategory;
      userContact.senderCommChanel = this.getPreferredCommChannel();
      if (this.timeSlotType == "Custom") {
        userContact.senderStartTime = TimeZoneUtils.convertOnlyTimeToUTC(this.fromTime, this.currentUserTimeZone);
        userContact.senderEndTime = TimeZoneUtils.convertOnlyTimeToUTC(this.toTime, this.currentUserTimeZone);
      } else {
        userContact.senderPrefTime = preferredTimeSlots;
      }
    } else {
      // Reciever side
      userContact.recieverCategory = this.selectedCategory;
      userContact.recieverCommChanel = this.getPreferredCommChannel();
      if (this.timeSlotType == "Custom") {
        userContact.recieverStartTime = TimeZoneUtils.convertOnlyTimeToUTC(this.fromTime, this.currentUserTimeZone);
        userContact.recieverEndTime = TimeZoneUtils.convertOnlyTimeToUTC(this.toTime, this.currentUserTimeZone);
      } else {
        userContact.recieverPrefTime = preferredTimeSlots;
      }
    }
    // console.log("To Be Updated: ", userContact);
    this.updateContactInner(userContact);
  }

  updateContactInner(userContact: any) {
    this.loader.show("Please wait...");
    this.authService.postEncrypt('user/directory?' + this.requestPath + '=update', userContact)
      .subscribe((res: any) => {
        this.loader.hide();
        if (res.success) {
          // Close modal and move to connection list page
          this.dismiss('');
          this.router.navigate(['directory-dashbord-new']);
        } else {
          this.errorMessage = res.message;
        }
      }, (error: any) => {
        this.loader.hide();
        this.errorMessage = "Something went wrong, please try again.";
      });
  }
}
